import React, { useState } from "react";
import "./POPPage.css";

export default function POPPage() {
  // Example placeholder data; you’ll eventually replace this with DB-driven or API data
  const [completedRequests] = useState([
    {
      id: 1,
      title: "POP Display Setup",
      tag: "POP",
      date: "2025-10-15",
      requester: "John Doe",
      email: "john@example.com",
    },
    {
      id: 2,
      title: "POP Retail Campaign",
      tag: "POP",
      date: "2025-10-20",
      requester: "Marketing Team",
      email: "marketing@example.com",
    },
    {
      id: 3,
      title: "Non-POP Maintenance",
      tag: "General",
      date: "2025-10-22",
      requester: "Ops Team",
      email: "ops@example.com",
    },
  ]);

  // Filter only “POP” items
  const popRequests = completedRequests.filter(
    (r) => r.tag && r.tag.toLowerCase().includes("pop")
  );

  return (
    <div className="pop-page">
      <h1>POP Completed Requests</h1>

      {popRequests.length > 0 ? (
        <table className="pop-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Tag</th>
              <th>Date</th>
              <th>Requester</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {popRequests.map((r) => (
              <tr key={r.id}>
                <td>{r.title}</td>
                <td>{r.tag}</td>
                <td>{r.date}</td>
                <td>{r.requester}</td>
                <td>{r.email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No completed POP requests available.</p>
      )}
    </div>
  );
}
